import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const api = axios.create({
  baseURL: "https://nightingale-intelligence-core.onrender.com",
});

// --- AIR QUALITY ---
export const useGlobalAirQuality = (parameter) =>
  useQuery({
    queryKey: ["air-quality", "global", parameter],
    queryFn: () => api.get("/v1/hh/air-quality/global", { params: { parameter, limit: 100 } }).then(r => r.data),
  });

export const useAirQualityHotspots = (parameter = "pm25", topN = 10) =>
  useQuery({
    queryKey: ["air-quality", "hotspots", parameter],
    queryFn: () => api.get("/v1/hh/air-quality/hotspots", { params: { parameter, top_n: topN } }).then(r => r.data),
  });

export const useWeeklyAirAverage = (parameter = "pm25") =>
  useQuery({
    queryKey: ["air-quality", "weekly-avg", parameter],
    queryFn: () => api.get("/v1/hh/air-quality/weekly-average", { params: { parameter } }).then(r => r.data),
    staleTime: 30 * 60 * 1000,
  });

// --- WEATHER ---
export const useGlobalWeather = () =>
  useQuery({
    queryKey: ["weather", "global"],
    queryFn: () => api.get("/v1/twn/weather/global-summary").then(r => r.data),
  });

export const useWeeklyWeatherTrends = (region) =>
  useQuery({
    queryKey: ["weather", "trends", region],
    queryFn: () => api.get("/v1/twn/weather/weekly-trends", { params: { region } }).then(r => r.data),
  });

export const useExtremeEvents = () =>
  useQuery({
    queryKey: ["weather", "extreme"],
    queryFn: () => api.get("/v1/twn/weather/extreme-events").then(r => r.data),
    staleTime: 15 * 60 * 1000,
  });

// --- GIS & FIRE (Live Intel) ---
export const useFireHotspots = () =>
  useQuery({
    queryKey: ["gis", "fires"],
    queryFn: () => api.get("/v1/hh/gis/fire-hotspots").then(r => r.data),
    staleTime: 30 * 1000, 
    refetchInterval: 45 * 1000,
  });

export const useAirQualityGeoJSON = () =>
  useQuery({
    queryKey: ["gis", "aq-geojson"],
    queryFn: () => api.get("/v1/hh/gis/geojson/air-quality-overlay").then(r => r.data),
    staleTime: 60 * 60 * 1000,
  });

// --- SATELLITES ---
export const useSatelliteSummary = () =>
  useQuery({
    queryKey: ["satellites", "summary"],
    queryFn: () => api.get("/v1/hh/satellites/summary").then(r => r.data),
    staleTime: 60 * 60 * 1000,
  });

export const useSatellitesByCategory = (category) =>
  useQuery({
    queryKey: ["satellites", category],
    queryFn: () => api.get(`/v1/hh/satellites/by-category/${category}`).then(r => r.data),
  });

// --- ALERTS & REPORTS (FIXES THE BUILD ERROR) ---
export const useActiveAlerts = () =>
  useQuery({
    queryKey: ["alerts", "active"],
    queryFn: () => api.get("/v1/hh/alerts/active").then(r => r.data),
    refetchInterval: 5 * 60 * 1000,
  });

export const useWeeklyReport = () =>
  useQuery({
    queryKey: ["reports", "weekly"],
    queryFn: () => api.get("/v1/hh/reports/weekly").then(r => r.data),
    staleTime: 60 * 60 * 1000,
  });

export const useDashboardSummary = () =>
  useQuery({
    queryKey: ["reports", "summary"],
    queryFn: () => api.get("/v1/hh/reports/summary").then(r => r.data),
    refetchInterval: 10 * 60 * 1000,
  });
